import {
  AssignmentTurnedIn,
  AssessmentOutlined,
  Layers,
  School,
  Security,
} from '@mui/icons-material';
import React from 'react';
import { SourceType, sourceTypeConfig } from 'views/Findings/state';

import styles from './styles.module.css';

interface KPISectionIconProps {
  sectionKey: string;
  compact?: boolean;
}

const sectionAppearance: Record<
  string,
  { icon: JSX.Element; iconClassName: string }
> = {
  cloud_agents: {
    icon: <i className={sourceTypeConfig[SourceType.CA].iconClass} />,
    iconClassName: styles.iconBlue,
  },
  web_apps: {
    icon: <i className={sourceTypeConfig[SourceType.WAS].iconClass} />,
    iconClassName: styles.iconTeal,
  },
  endpoints: {
    icon: <i className={sourceTypeConfig[SourceType.EP].iconClass} />,
    iconClassName: styles.iconCyan,
  },
  sast: {
    icon: <i className={sourceTypeConfig[SourceType.SAST].iconClass} />,
    iconClassName: styles.iconNavy,
  },
  vanta: {
    icon: <Layers fontSize="small" />,
    iconClassName: styles.iconViolet,
  },
  training: {
    icon: <School fontSize="small" />,
    iconClassName: styles.iconGreen,
  },
  security_incidents: {
    icon: <Security fontSize="small" />,
    iconClassName: styles.iconRed,
  },
  vendor_assessments: {
    icon: <AssignmentTurnedIn fontSize="small" />,
    iconClassName: styles.iconOrange,
  },
};

const KPISectionIcon = ({ sectionKey, compact }: KPISectionIconProps) => {
  const appearance = sectionAppearance[sectionKey] || {
    icon: <AssessmentOutlined fontSize="small" />,
    iconClassName: styles.iconNavy,
  };

  return (
    <span
      aria-hidden="true"
      className={`${styles.sectionIcon} ${appearance.iconClassName} ${
        compact ? styles.sectionIconCompact : ''
      }`}
    >
      {appearance.icon}
    </span>
  );
};

export default KPISectionIcon;
